<div class="km-page">
	<header class="km-header">
		<!-- Logotipo oficial: el monograma y el nombre juntos. Suelto, el monograma
		     no dice de quién es la página en la que alguien acaba de terminar su alta. -->
		<img class="km-logo" src="assets/layout/images/branding/km-monogram.png" alt="" />
		<img class="km-word" src="assets/layout/images/branding/kairos-merit-wordmark-black.png" alt="Kairos Merit" />
	</header>

	<main class="km-main">
		@if (loading()) {
			<div class="km-state"><app-spinner [loading]="true"></app-spinner></div>
		} @else if (notFound()) {
			<div class="km-state">
				<h1>{{ 'publicForms.candidateComplete.title' | transloco }}</h1>
				<div class="km-alert" role="alert">
					<i class="pi pi-exclamation-circle" aria-hidden="true"></i>
					<span>{{ 'publicForms.candidateComplete.messages.invalidLink' | transloco }}</span>
				</div>
			</div>
		} @else if (done()) {
			<div class="km-state km-success">
				<div class="km-check" aria-hidden="true"><i class="pi pi-check"></i></div>
				<h1>{{ 'publicForms.candidateComplete.success.title' | transloco }}</h1>
				<p>{{ 'publicForms.candidateComplete.success.message' | transloco }}</p>
			</div>
		} @else {
			<header class="km-intro">
				<p class="km-eyebrow">{{ 'publicForms.candidateComplete.subtitle' | transloco }}</p>
				<h1>{{ 'publicForms.candidateComplete.title' | transloco }}</h1>
				<p class="km-lede">{{ 'publicForms.candidateComplete.intro' | transloco }}</p>
			</header>

			<section class="km-card">
				<h2>{{ 'publicForms.candidateComplete.applicationHeading' | transloco }}</h2>
				<dl class="km-fields">
					@for (row of applicationRows(); track row.labelKey) {
						<div class="km-field">
							<dt>{{ row.labelKey | transloco }}</dt>
							<dd>{{ row.value }}</dd>
						</div>
					}
				</dl>

				@if (languageSkills().length) {
					<h3>{{ 'publicForms.candidateComplete.languagesHeading' | transloco }}</h3>
					<ul class="km-langs">
						@for (l of languageSkills(); track l.language) {
							<li><span class="km-lang">{{ l.language }}</span><span class="km-level">{{ l.hint }}</span></li>
						}
					</ul>
				}
			</section>

			<form class="km-card km-upload" (submit)="$event.preventDefault(); submit()">
				<h2>{{ 'publicForms.candidateComplete.videoHeading' | transloco }}</h2>
				<p class="km-help">{{ 'publicForms.candidateComplete.videoHelp' | transloco }}</p>

				<app-file-upload
					[formControl]="videoFiles"
					[placeholder]="'publicForms.candidateApply.files.videoPlaceholder' | transloco"
				></app-file-upload>

				@if (serverError()) {
					<div class="km-alert" role="alert">
						<i class="pi pi-exclamation-circle" aria-hidden="true"></i>
						<span>{{ serverError() }}</span>
					</div>
				}

				<app-button
					class="km-submit"
					type="submit"
					[label]="(submitting() ? 'publicForms.candidateComplete.actions.submitting' : 'publicForms.candidateComplete.actions.submit') | transloco"
					variant="primary"
					size="large"
					[loading]="submitting()"
					[disabled]="submitting()"
				></app-button>
			</form>
		}
	</main>

	<footer class="km-footer">
		<div class="km-footer-brand">KAIROS MERIT</div>
		<div class="km-tagline">The Right Time for Talent.</div>
		<div class="km-legal">Kairos Merit Staffing Solutions — FZCO · Dubai, United Arab Emirates</div>
	</footer>
</div>
